import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type NegativeCharacterCountProps = {
	count: number; // parent component computes how many characters are over the limit
};

const styles = cssMap({
	wrapper: {
		backgroundColor: token('color.background.danger.pressed'),
		borderColor: token('color.border.danger'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderRadius: token('radius.small', '3px'),
		paddingTop: token('space.025'),
		paddingRight: token('space.075'),
		paddingBottom: token('space.025'),
		paddingLeft: token('space.075'),
		display: 'inline-block',
		width: 'fit-content',
	},
});

export const NegativeCharacterCount = ({
	count,
}: NegativeCharacterCountProps): React.JSX.Element | null => {
	const exceedsLimit = count < 0;

	if (exceedsLimit) {
		return (
			<Box xcss={styles.wrapper}>
				<Text
					color="color.text"
					size="small"
					weight="medium"
					testId="conversation-assistant-chat-prompt-input.text.negative-counter"
				>
					{count}
				</Text>
			</Box>
		);
	}

	return null;
};
